import { encode } from "base64-xor";

import { FINGERPRINT_CIPHER, FINGERPRINT_SIGNATURE, FINGERPRINT_VERSION } from "../config";

// Webgl detect
let gl = null;
let glDebug = null;
try {
    const canvas = document.createElement("canvas");
    gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
    glDebug = gl.getExtension('WEBGL_debug_renderer_info');
} catch (e) { } // eslint-disable-line no-empty

// NavigatorProperties
const navigatorProperties = [];
try {
    for (const v in window.navigator) {
        navigatorProperties.push(v);
    }
} catch (e) { } // eslint-disable-line no-empty

export const fingerprint = () => {
    try {
        const r = (f) => {
            try {
                const v = f();
                if (typeof v === 'undefined') {
                    return null;
                }
                return v;
            } catch (err) { } // eslint-disable-line no-empty
            return null;
        }

        const values = {
            v: FINGERPRINT_VERSION,
            t: new Date().getTime(),
            d: [
                r(() => window.navigator.userAgent), // 1 - User agent
                r(() => window.navigator.platform), // 2 - Platform
                r(() => window.navigator.cookieEnabled), // 3 - Cookies enabled
                r(() => Intl.DateTimeFormat().resolvedOptions().timeZone), // 4 - Timezone
                r(() => new Date().getTimezoneOffset()), // 4 - Timezone offset
                r(() => navigator.languages.join(',')),  // 5 - Languages
                r(() => window.navigator.doNotTrack), // 9 - DNT
                r(() => navigatorProperties), // Properties of navigator
                r(() => navigator.buildID), // 11 - build id
                r(() => navigator.product), // 12 - product
                r(() => navigator.productSub), // 13 Product sub
                r(() => navigator.vendor), // 14 - Vendor
                r(() => navigator.vendorSub), // 15 - Vendor sub
                r(() => navigator.hardwareConcurrency), // 16 - hardwareConcurrency
                r(() => navigator.javaEnabled()), // 17 - Java enabled
                r(() => navigator.pdfViewerEnabled), // 17 - PDF viewer
                r(() => navigator.deviceMemory), //18 device memory
                r(() => window.screen.colorDepth), // 22 - screen depth color
                r(() => gl.getParameter(glDebug.UNMASKED_VENDOR_WEBGL)),//28 - Webgl vendor
                r(() => gl.getParameter(glDebug.UNMASKED_RENDERER_WEBGL)),//29 - Webgl renderer
                r(() => window.key) // 47 - key
            ]
        }

        //console.log('FINGERPRINT', values);

        const encodeToken = v => encode(FINGERPRINT_SIGNATURE, encode(FINGERPRINT_CIPHER, JSON.stringify(v)).split("").reduce((acc, char) => char + acc, ""));
        return encodeToken(values);
    } catch (e) {
        return 'null';
    }
}